import {
  StackOverflowIcon_default
} from "./chunk-DT2NDWZJ.mjs";
export {
  StackOverflowIcon_default as default
};
